import OrderComputationsAsync from 'shared/order/computations-async';
import { CALCULATION_PRICE_SERVICE } from 'shared/constants';
import { datadogLogs } from '@datadog/browser-logs';

async function performCalculations({
  cart,
  apolloClient,
  userId,
  consolidateReceiptDiscountsEnabled,
  deliveryScheduleTypeEnabled,
  platformType,
  preOrderType,
  handleQtyPricingTierProducts,
  ecommKeyMatchingEnabled,
}) {
  const initialCalculationIndex = cart.calculationIndex;

  const discountSyncEnabled = cart.dispensary?.storeSettings?.enableLLxSaleDiscountSync ?? false;

  let calculationOutput;

  const calculationsInput = {
    ...cart.order,
    cartAddress: cart.address,
    discountSyncEnabled,
    userId,
    couponActions: {
      removeCoupon: cart.removeCoupon,
      applyCouponCode: cart.applyCouponCode,
    },
    rewardActions: {
      removeReward: cart.undoApplyReward,
    },
    priceService: CALCULATION_PRICE_SERVICE.cart,
    consolidateReceiptDiscountsEnabled,
    deliveryScheduleType: deliveryScheduleTypeEnabled ? cart.reservationType : null,
    bypassCanadaDeliveryTax: cart.bypassCanadaDeliveryTax,
    platformType,
    preOrderType,
    handleQtyPricingTierProducts,
    ecommKeyMatchingEnabled,
  };

  const input = {
    data: calculationsInput,
    logger: datadogLogs.logger,
    apolloClient,
  };

  try {
    calculationOutput = await OrderComputationsAsync.compute(input);
  } catch (error) {
    datadogLogs.logger.error('Error in performCalculationsAction', error);
    calculationOutput = {};
  }

  if (initialCalculationIndex === cart.calculationIndex) {
    cart.setCalculationOutput(calculationOutput);
    cart.setDiscountGamification(calculationOutput?.gamificationDetails ?? []);
    cart.setIsCalculating(false);

    return calculationOutput;
  }

  return undefined;
}

export default {
  performCalculations,
};
